// extracted by mini-css-extract-plugin
export var numpadContainer = "_rg-1";
export var phoneButton = "_rg-0";